import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import {
  Card,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import { Link, Navigate } from "react-router-dom";

export default class WebContacts extends Component {
  state = {
    allJobs: [],
    message: "",
    notification: false,
    noticolor: "success",

    // pagination
    page: 1,
    limit: 10,
    totalPages: 1,
    totalDocs: 0,

    redirect: false,

    // delete modal
    deleteModal: false,
    deleteId: null,
  };

  componentDidMount() {
    this.getAllWebContacts();
  }

  getAllWebContacts = () => {
    if (init() !== "success") {
      window.location.assign("/signin");
      return;
    }

    const { page, limit } = this.state;

    axios
      .get(Constants.getUrls.getAllContacts, {
        params: { page, limit },
      })
      .then((resp) => {
        if (resp.data.status === "success") {
          const data = resp.data.data;

          this.setState({
            allJobs: data.docs,
            totalPages: data.totalPages,
            totalDocs: data.totalDocs,
            page: data.page,
          });
        }
      })
      .catch((err) => {
        this.setState({
          notification: true,
          message: "Failed to load contacts",
          noticolor: "error",
        });
      });
  };

  // pagination handlers
  handleNext = () => {
    if (this.state.page < this.state.totalPages) {
      this.setState(
        (prev) => ({ page: prev.page + 1 }),
        this.getAllWebContacts,
      );
    }
  };

  handlePrev = () => {
    if (this.state.page > 1) {
      this.setState(
        (prev) => ({ page: prev.page - 1 }),
        this.getAllWebContacts,
      );
    }
  };

  // open confirmation modal
  openDeleteModal = (id) => {
    this.setState({ deleteModal: true, deleteId: id });
  };

  closeDeleteModal = () => {
    this.setState({ deleteModal: false, deleteId: null });
  };

  handleDelete = () => {
    const { deleteId } = this.state;

    axios
      .delete(Constants.deleteUrls.deleteContact + deleteId)
      .then((resp) => {
        if (resp.data.status === "success") {
          this.setState(
            {
              notification: true,
              message: resp.data.message,
              noticolor: "success",
              deleteModal: false,
              deleteId: null,
            },
            this.getAllWebContacts,
          );
        }
      })
      .catch(() => {
        this.setState({
          notification: true,
          message: "Delete failed",
          noticolor: "error",
          deleteModal: false,
        });
      });
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/signin" replace />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Web-Contact List
              </MDTypography>
            </MDBox>

            <Grid item sm={4} px={2} align="right">
              <Link to="/addLevel">
                <MDButton variant="contained" size="small" color="primary">
                  Create
                </MDButton>
              </Link>
            </Grid>

            <MDBox>
              <DataTable
                table={{
                  columns: [
                    { Header: "serial", accessor: "serial" },
                    { Header: "name", accessor: "name" },
                    { Header: "email", accessor: "email" },
                    { Header: "mobile", accessor: "mobile" },
                    { Header: "company", accessor: "company" },
                    { Header: "industry", accessor: "industry" },
                    { Header: "enquiry", accessor: "enquiry" },
                    { Header: "message", accessor: "message" },
                    { Header: "action", accessor: "action" },
                  ],
                  rows: this.state.allJobs.map((job, index) => ({
                    serial:
                      (this.state.page - 1) * this.state.limit + index + 1,
                    name: job.name,
                    email: job.email,
                    mobile: job.mobile,
                    company: job.company,
                    industry: job.industry,
                    enquiry: job.enquiry,
                    message: job.message,
                    action: (
                      <MDButton
                        variant="outlined"
                        size="small"
                        color="error"
                        onClick={() => this.openDeleteModal(job._id)}
                      >
                        Delete
                      </MDButton>
                    ),
                  })),
                }}
              />
            </MDBox>

            {/* Pagination */}
            <MDBox display="flex" justifyContent="space-between" px={3} py={2}>
              <MDButton
                variant="outlined"
                disabled={this.state.page === 1}
                onClick={this.handlePrev}
              >
                Prev
              </MDButton>

              <MDTypography variant="button">
                Page {this.state.page} of {this.state.totalPages}
              </MDTypography>

              <MDButton
                variant="outlined"
                disabled={this.state.page === this.state.totalPages}
                onClick={this.handleNext}
              >
                Next
              </MDButton>
            </MDBox>

            {/* Delete Confirmation Modal */}
            <Dialog
              open={this.state.deleteModal}
              onClose={this.closeDeleteModal}
            >
              <DialogTitle sx={{ color: "#000" }}>Confirm Delete</DialogTitle>

              <DialogContent>
                <MDTypography sx={{ color: "#000" }}>
                  Are you sure you want to delete this contact enquiry?
                </MDTypography>
              </DialogContent>

              <DialogActions>
                <MDButton onClick={this.closeDeleteModal}>Cancel</MDButton>
                <MDButton color="error" onClick={this.handleDelete}>
                  Delete
                </MDButton>
              </DialogActions>
            </Dialog>

            <MDSnackbar
              color={this.state.noticolor}
              icon="notifications"
              title="AgriQuiz"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
